import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles()({
  minusIcon: {
    cursor: 'pointer',
    height: '15px',
  },
  plusIcon: {
    cursor: 'pointer',
    height: '15px',
    marginRight: '-2px',
  },
  containerClosed: {
    height: 0,
    transformOrigin: '0 0 0',
  },
  container: {
    marginTop: '10px',
    width: '100%',
    maxHeight: '300px',
    overflowY: 'auto',
    transformOrigin: '0 0 0',
  },
});
